var map = {
	"./Slide-a.jpeg": 2404,
	"./Slide-b.JPG": 2091,
	"./Slide-c.jpg": 4473,
	"./Slide-d.jpg": 3578,
	"./Slide-e.jpg": 5767,
	"./Slide-f.jpg": 1960,
	"./Slide-g.jpg": 9829,
	"./Slide-h.jpg": 3286,
	"./Slide-i.jpg": 6419,
	"./Slide-j.jpg": 356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9654;